import React, { useState } from "react";
import { projectsData } from "../projectData";


  export const projects = [
    {
      title: "CUB-3D",
      description:
        "This project aims to explore raycasting by creating a simulated 3D environment.",
      link: "https://github.com/Yichiba/CUB-3D",
    },
    {
      title: "Inception",
      description:
        "Sorting algorithm project at 42 school, aiming to sort numbers efficiently.",
      link: "https://github.com/Yichiba/Push-Swap",
    },
    {
      title: "ft_transcendence",
      description: "Concurrency problem simulation using threads and mutexes.",
      link: "https://github.com/Yichiba/Philosophers",
    },
    {
      title: "WebServer",
      description:
        "A custom HTTP server built in C that handles multiple connections.",
      link: "https://github.com/Yichiba/WebServer",
    },
    // {
    //   title: "MiniShell",
    //   description:
    //     "A minimal shell implementation that mimics bash with pipes and redirections.",
    //   link: "https://github.com/Yichiba/MiniShell",
    // },
  ];

export function ProjectCard({ title,setPopup}) {
  const[hover, setHover]=useState(null)
  return (
    <div className="flex   flex-col !w-full sm:!w-[350px]   gap-3  py-4">
      <div className="relative h-[233px] rounded-md   ">
        <img
          onMouseEnter={() => setHover(title)}
          className={`w-full h-full rounded-md `}
          src={projectsData[title]["Image"]}
          alt=""
        />
        {hover && (
          <div
            onClick={() => setPopup(title)}
            onMouseLeave={() => setHover(null)}
            className="  absolute top-0 left-0 h-full w-full"
          >
            <div className="bg-black w-full h-full  opacity-40"></div>
            <div className=" flex  h-full justify-center items-center absolute top-0 left-0 ">
              <div className="flex w-2/3 flex-wrap items-center justify-center gap-1">
                {projectsData[title]["TechStack"].map((e,index) => {
                  return (
                    <text key={index} className=" text-sm border-2 border-white text-white rounded-xl px-2 hover:bg-white hover:text-black">
                      {e.split("-")[0]}
                    </text>
                  );
                })}
              </div>
            </div>
          </div>
        )}
      </div>
      <h1 className=" font-bold text-xl">{title}</h1>
      <p className="font-serif  h-[95px] text-sm">
        {projectsData[title]['entro']}
      </p>
      <a className="w-fit rounded-md" onClick={() => setPopup(title)}>
        VIEW PROJECT
      </a>
    </div>
  );
}
